/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ClientDTO } from '../models/ClientDTO';
import type { ClientDTOODataListResponse } from '../models/ClientDTOODataListResponse';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class ClientsService {

    /**
     * @param top The max number of records.
     * @param skip The number of records to skip.
     * @param filter A function that must evaluate to true for a record to be returned.
     * @param select Specifies a subset of properties to return. Use a comma separated list.
     * @param orderby Determines what values are used to order a collection of records.
     * @param expand Use to add related query data.
     * @param count Include the overall count
     * @returns ClientDTOODataListResponse Success
     * @throws ApiError
     */
    public static getBackendClients(
top?: string,
skip?: string,
filter?: string,
select?: string,
orderby?: string,
expand?: string,
count?: string,
): CancelablePromise<ClientDTOODataListResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/backend/clients',
            query: {
                '$top': top,
                '$skip': skip,
                '$filter': filter,
                '$select': select,
                '$orderby': orderby,
                '$expand': expand,
                '$count': count,
            },
        });
    }

    /**
     * @param requestBody 
     * @returns ClientDTO Success
     * @throws ApiError
     */
    public static postBackendClients(
requestBody?: ClientDTO,
): CancelablePromise<ClientDTO> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/backend/clients',
            body: requestBody,
            mediaType: 'application/json;odata.metadata=minimal;odata.streaming=true',
        });
    }

    /**
     * @param key 
     * @returns ClientDTO Success
     * @throws ApiError
     */
    public static getBackendClients1(
key: number,
): CancelablePromise<ClientDTO> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/backend/clients/{key}',
            path: {
                'key': key,
            },
        });
    }

    /**
     * @param key 
     * @param requestBody 
     * @returns ClientDTO Success
     * @throws ApiError
     */
    public static putBackendClients(
key: number,
requestBody?: ClientDTO,
): CancelablePromise<ClientDTO> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/backend/clients/{key}',
            path: {
                'key': key,
            },
            body: requestBody,
            mediaType: 'application/json;odata.metadata=minimal;odata.streaming=true',
        });
    }

    /**
     * @param key 
     * @returns any Success
     * @throws ApiError
     */
    public static deleteBackendClients(
key: number,
): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/backend/clients/{key}',
            path: {
                'key': key,
            },
        });
    }

    /**
     * @param key 
     * @returns any Success
     * @throws ApiError
     */
    public static getBackendClientsLogo(
key: number,
): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/backend/clients/{key}/logo',
            path: {
                'key': key,
            },
        });
    }

    /**
     * @param key 
     * @param formData 
     * @returns any Success
     * @throws ApiError
     */
    public static postBackendClientsLogo(
key: number,
formData?: {
file?: Blob;
},
): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/backend/clients/{key}/logo',
            path: {
                'key': key,
            },
            formData: formData,
            mediaType: 'multipart/form-data',
        });
    }

}
